/**
 * Adjust product report rows and summary totals when QR ordering is disabled.
 * Excludes QR quantity and sales from totalQty / totalSales.
 */
export const normalizeProductReportData = (
  products,
  { totalProducts, totalQty, totalSales },
  qrEnabled
) => {
  if (qrEnabled) {
    return {
      products: products || [],
      totalProducts: totalProducts ?? 0,
      totalQty: totalQty ?? 0,
      totalSales: totalSales ?? 0,
    };
  }

  const normalizedProducts = (products || []).map((product) => {
    const dineInQty = Number(product.dineInQty) || 0;
    const takeawayQty = Number(product.takeawayQty) || 0;
    const onlineQty = Number(product.onlineQty) || 0;
    const qrSales = Number(product.qrSales) || 0;
    const rowTotalSales = Number(product.totalSales) || 0;

    return {
      ...product,
      qrQty: 0,
      totalQty: dineInQty + takeawayQty + onlineQty,
      totalSales: Math.max(0, rowTotalSales - qrSales),
    };
  });

  return {
    products: normalizedProducts,
    totalProducts: totalProducts ?? normalizedProducts.length,
    totalQty: normalizedProducts.reduce(
      (sum, product) => sum + (Number(product.totalQty) || 0),
      0
    ),
    totalSales: normalizedProducts.reduce(
      (sum, product) => sum + (Number(product.totalSales) || 0),
      0
    ),
  };
};
